export const iconFontAwesomeChildhoodBaseballBatBall = (
	<i className="fa-solid fa-baseball-bat-ball"></i>
);
